import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RimsPhaseCardComponent } from '@app/pages/incidents/details-page/rims/rims-phase-card/rims-phase-card.component';
import { SectionMenuComponent } from '@app/components/section-menu/section-menu.component';
import { RimsPhaseInfo } from '@app/models/rims.model';
import { RimsState } from '@app/store/app/states/rims/rims.state';
import { Store } from '@ngxs/store';
import { firstValueFrom } from 'rxjs';

@Component({
  standalone: true,
  selector: 'app-rims.page',
  imports: [
    CommonModule,
    MatButtonModule,
    MatCardModule,
    MatChipsModule,
    MatDialogModule,
    MatIconModule,
    MatTooltipModule,
    RimsPhaseCardComponent,
    SectionMenuComponent,
  ],
  templateUrl: './rims.page.component.html',
  styleUrl: './rims.page.component.scss',
})
export class RimsPageComponent implements OnInit {
  protected rimsPhaseInfos: RimsPhaseInfo[] = [];

  constructor(private readonly store: Store) {}

  async ngOnInit(): Promise<void> {
    this.rimsPhaseInfos = await firstValueFrom(this.store.select(RimsState.getRimsPhaseInfos));
  }
}
